module.exports = __webpack_public_path__ + "static/img/8029_phase_function_Paper_PointsHejduk_Prediction.2c25e75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8029_phase_function_Paper_PointsHejduk_Prediction.png
// module id = QDBP
// module chunks = 0